<template>
  <v-dialog v-model="dialog" scrollable persistent width="800px">
    <v-card>
      <v-card-title class="blue darken-4 white--text">
        <span class="text-center headline"> Seleccionar Concepto :) </span>
      </v-card-title>
      <v-card-text> 
        <v-container>
          <v-data-table
            v-model="selected"
            :headers="headers"
            :items="desserts"
            :single-select="singleSelect"
            :loading="loading_conceptos"
            disable-pagination
            hide-default-footer
            item-key="id"
            show-select
            class="elevation-1"
          >
          <template v-slot:[`item.opcional`]="{ item }">
            <span> {{ item.opcional?'SI':'NO' }} </span>
          </template>
          
          </v-data-table>
        </v-container>

        <p class="text-center red--text">{{ msg }}</p>
        <v-progress-linear indeterminate v-if="loading_conceptos" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" rounded outlined @click="enviarSeleccionados()">
          <v-icon class="mx-1">mdi-content-save</v-icon> Guardar</v-btn
        >
        <v-btn rounded outlined @click="dialog = !dialog"> <v-icon>mdi-close</v-icon> Cancelar </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  import xaxios from '@/xaxios';
  export default {
    props:{
      opcionales: {type:Boolean, default:true}
    },
    data() {
      return {
        dialog: false,
        loading: false,
        loading_conceptos: false,
        msg: '',
        singleSelect: false,
        selected: [],
        desserts: [],
        headers: [
          { text: 'Concepto', value: 'nombre' },
          { text: 'ID', value: 'id' },
          { text: 'Opcional', value: 'opcional' },
        ],
      };
    },
    computed: {},
    watch: {},
    methods: {
      openmodal(unidadessel) {
        this.dialog = true;
        this.getconceptos(unidadessel);
      },
      getconceptos(unidadessel) {
        //window.console.log('unidadessel:', unidadessel);
        let idunidad = -1;
        window.console.log();
        if (unidadessel) {
          idunidad = unidadessel[0].id;
        } else {
          idunidad = this.$store.state.CARGO.sede.unidad_negocio;
        }
        this.desserts = [];
        let vue = this;
        vue.loading_conceptos = true;

        var config = {
          method: 'post',
          //url: `${process.env.VUE_APP_API_REST}/api/v1/esam/conceptospagos`,
          url: `${process.env.VUE_APP_API_REST}/api/pagos/conceptos/buscar`,
          headers: {
            'Content-Type': 'application/json',
          },
          data: {
            es_nacional: false,
            // text: 'string',
            unidad_negocio_id: idunidad,
          },
        };

        if (idunidad == -1) {
          delete config.data.unidad_negocio_id;
        }

        xaxios.request(config)
          .then(function(response) {
            let data = response.data;
            window.console.log('data:::', response);
            data.map((c) => {
              c.nro = c.id; 
            });
            if(idunidad == 14) data.sort((a, b) => b.id - a.id);
            // window.console.log('data',data);

            if(!vue.opcionales){
              const filtrados = data.filter(c=>c.opcional==false); 
              data = filtrados;
            }
            vue.desserts = data;
            //window.console.log(filtrados);
            vue.loading_conceptos = false;
          })
          .catch(function(error) {
            window.console.log(error);
            vue.loading_conceptos = false;
          });
      },
      enviarSeleccionados() {
        this.$emit('conceptos_sel', this.selected);
        this.dialog = false;
      },
    },
  };
</script>
